import { SimpleSearchFilter } from 'module/api/filter/types';
import {
  defaultGroupedFilter,
  GroupedFilter,
} from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { isFieldFilterValid } from 'module/types/filter-field/grouped-filter/utils';
import { Breadcrumb } from 'module/ui/components/atoms/breadcrumb';
import { DrawerBreadCrumbs } from 'module/ui/components/atoms/drawer';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { GroupedFilterDrawer } from 'module/ui/components/molecules/field-filter/drawer/grouped-filter-drawer';
import { getApiGroupedFilterTransformer } from 'module/ui/components/molecules/field-filter/filter-transformation/api-grouped-filter-transformer';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { FC, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAiPagesFields } from './use-field';
import { FolderItem } from '../folder-content/types';

interface Props {
  file?: FolderItem;
  filter?: SimpleSearchFilter;
  onDone: (filter: SimpleSearchFilter | null) => void;
  visible: boolean;
  onClose: () => void;
}
export const EditFilterConditionDrawer: FC<Props> = ({
  filter: apiFilter,
  onDone: onDoneCallback,
  visible,
  onClose,
  file,
}) => {
  const { fields, lookups } = useAiPagesFields();
  const filterTransformer = useMemo(() => {
    return getApiGroupedFilterTransformer(lookups, FilterGroupType.Company);
  }, [lookups]);
  const filter = useMemo(() => {
    return apiFilter
      ? filterTransformer.from(apiFilter)
      : defaultGroupedFilter(FilterGroupType.Company);
  }, [apiFilter, filterTransformer]);

  const onDone = useCallback(
    (filter: GroupedFilter) => {
      const hasValidCriteria =
        filter.groupCriteria.filter(({ criteria }) =>
          isFieldFilterValid(criteria),
        ).length > 0;

      if (!hasValidCriteria) {
        onDoneCallback(null);
      }
      onDoneCallback(filterTransformer.to(filter));
    },
    [filterTransformer, onDoneCallback],
  );
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: file?.name,
        link: '',
      },
    ];
  }, [file]);

  return (
    <GroupedFilterDrawer
      title={
        <>
          <Breadcrumb separator="">
            <DrawerBreadCrumbs breadcrumbs={breadcrumbs} />
          </Breadcrumb>
          <div className="flex items-center gap-03">
            <FontAwesomeIcon icon={faFilter} />
            <FormattedMessage id="knowledge_base.edit_filter_condition.title" />
          </div>
        </>
      }
      hasAiQuery={false}
      hideRemoveButton={true}
      fields={fields}
      filter={filter}
      onChange={onDone}
      visible={visible}
      onClose={onClose}
    />
  );
};
